import type { Strings } from '../../i18n/strings';
import type { ClassesData, RoleSpec } from './api';

/** "Before / After" in plain words for a role change (spec E2). */
export function roleReach(t: Strings, r: RoleSpec, classes: ClassesData | null): string {
  switch (r.role) {
    case 'head_of_school':
      return t['pa.reachHead'];
    case 'school_admin':
      return t['pa.reachAdmin'];
    case 'counsellor':
      return r.scope_grade_ids && r.scope_grade_ids.length > 0
        ? t['pa.reachCounsellorGrades'](
            r.scope_grade_ids.map((g) => classes?.grades.find((x) => x.id === g)?.label ?? '?').join(', '),
          )
        : t['pa.reachCounsellorAll'];
    case 'teacher':
      return r.classes && r.classes.length > 0
        ? t['pa.reachTeacher'](
            r.classes.map((c) => classes?.classes.find((x) => x.id === c.class_id)?.label ?? '?').join(', '),
          )
        : t['pa.reachTeacherNone'];
  }
}
